<script lang="ts">
    import cn from '$common/utils/cn';
    import SecondaryFiltersContent from '$saga/views/Search/SecondaryFilters/SecondaryFiltersContent.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    // ab test
    export let openAccordions: boolean;

    // Watch for changes in hideVerticalBar to adjust layout
    $: {
        const searchEngineSection = document.getElementById(
            'search-engine-section',
        );
        const searchAdminSection = document.getElementById(
            'search-admin-section',
        );
        const adminLandingFilterButton = document.getElementById(
            'admin-landing-filter',
        );

        if ($filtersContext.hideVerticalBar) {
            searchEngineSection?.classList.remove('desktop:gap-2xl', 'gap-2xl');
            document
                .getElementById('result-cards')
                ?.classList.add('desktop:grid-cols-4');
            document
                .getElementById('result-cards')
                ?.classList.remove('desktop:grid-cols-3');
            searchAdminSection?.classList.add('desktop:hidden');
            adminLandingFilterButton?.classList.add('hidden');
        } else {
            searchEngineSection?.classList.remove('gap-2xl');
            searchEngineSection?.classList.add('desktop:gap-2xl');
            document
                .getElementById('result-cards')
                ?.classList.remove('desktop:grid-cols-4');
            document
                .getElementById('result-cards')
                ?.classList.add('desktop:grid-cols-3');
            searchAdminSection?.classList.remove('desktop:hidden');
            adminLandingFilterButton?.classList.remove('hidden');
        }
    }
</script>

<div
    class={cn(
        'h-fit w-full min-w-[300px] max-w-[300px] border border-t-0 border-solid border-border-quiet bg-white px-s transition-all',
        $filtersContext.hideVerticalBar && 'hidden',
    )}
>
    <div class="flex flex-col gap-m py-m">
        <SecondaryFiltersContent {openAccordions} />
    </div>
</div>

<!-- Secondary filters inputs -->
{#each $filtersContext.formValues.levels as level (level)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="level[]"
        value={level}
    />
{/each}

{#each $filtersContext.formValues.types as type (type)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="type[]"
        value={type}
    />
{/each}

{#if null !== $filtersContext.formValues.durationMin}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="durationMin"
        value={$filtersContext.formValues.durationMin}
    />
{/if}

{#if null !== $filtersContext.formValues.durationMax}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="durationMax"
        value={$filtersContext.formValues.durationMax}
    />
{/if}

{#if null !== $filtersContext.formValues.budgetMin}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="budgetMin"
        value={$filtersContext.formValues.budgetMin}
    />
{/if}

{#if null !== $filtersContext.formValues.budgetMax}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="budgetMax"
        value={$filtersContext.formValues.budgetMax}
    />
{/if}

{#each $filtersContext.formValues.tags as tag (tag)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="tag[]"
        value={tag}
    />
{/each}

{#each $filtersContext.formValues.resorts as resort (resort)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="resort[]"
        value={resort}
    />
{/each}

{#if $filtersContext.formValues.bestReviewed}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        id="bestReviewed"
        name="bestReviewed"
        value="1"
    />
{/if}

{#if $filtersContext.formValues.exclusiveSport}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        id="exclusiveSport"
        name="exclusiveSport"
        value="1"
    />
{/if}
